import angular from 'angular';
import emailTemplatesSharingPrivacy from './emailTemplatesSharingPrivacy';
import './style.scss';

export default angular
  .module('components.emailTemplatesSharingPrivacy', [])
  .component('emailTemplatesSharingPrivacy', emailTemplatesSharingPrivacy).name;
